import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { MainBox } from 'modules/theme';
import { Header, Body, Footer } from './layout';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { globalAction } from 'store/action';
import { globalStateSelector } from 'store/selector';
import { withRouter } from 'react-router';
import { CHAT_SCREEN_URL } from '../../consts';

const ChatWidget = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  position: fixed;
  right: 17px;
  background: #0462ed;
  bottom: 10px;
  transition: transform 0.16s linear 0s, opacity 0.08s linear 0s;
  color: white;
  padding: 20px 18px 10px 16px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1111;
`;


export class DialpadWidget extends Component {
  constructor(props) {
    super(props);
    this.renderPopup = this.renderPopup.bind(this);
  }
  renderPopup() {
    const { dynamicUpdate, location = {} } = this.props
    const { pathname } = location;
    if(pathname === CHAT_SCREEN_URL) return null;
    return (
      <ChatWidget onClick={() => {
        dynamicUpdate({ key: 'isWidgetOpen', value: true });
      }}>
        <i >
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M.75 3.07a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0zm8.93 0a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0zm8.93 0a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0zM.75 12a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0zm8.93 0a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0zm8.93 0a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0zM9.749 20.93a2.32 2.32 0 1 1 4.64 0 2.32 2.32 0 0 1-4.64 0z" stroke="#fff" stroke-width="1.5"></path></svg>
        </i>
      </ChatWidget>
    )
  }
  render() {
    const { isWidgetOpen } = this.props
    return (
      isWidgetOpen
        ? <MainBox style={{ zIndex: 99999, transition: '0.7s ease', overflow: 'visible' }}>
          <Header />
          <Body />
          <Footer />
        </MainBox>
        : this.renderPopup()
    )
  }
}
const stateToProps = state => ({
  isWidgetOpen: globalStateSelector.getDynamic(state, { key: 'isWidgetOpen' }),
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default withRouter(connect(stateToProps, dispatchToProps)(DialpadWidget));



// WEBPACK FOOTER //
// src/dialpad/components/DialpadWidget.js